// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1ffyF","large":"styles_large__3VZhO"};